import {
  ContextMenuPayload,
  SET_CONTEXT_MENU_VISIBILITY,
  SET_SELECTED_ITEM_ID,
  UPDATE_SELECTED_ITEMS,
  CLEAR_SELECTED_ITEMS,
  SET_MULTIPLE_SELECTION,
} from "./types";
import { getParentId } from '../../../helpers/commonFunction'

const initialState: any = {
  visibility: false,
  coordinates: {
    top: 0,
    left: 0,
  },
  selectedItemId: "",
  selectedItemsId: [],
  isMultipleSelection: false,
};

export function contextMenuReducer(
  state = initialState,
  action: ContextMenuPayload
) {
  switch (action.type) {
    case SET_CONTEXT_MENU_VISIBILITY:
      return {
        ...state,
        ...action.data,
      };
    case SET_SELECTED_ITEM_ID:
      return {
        ...state,
        selectedItemId: action.data,
      };
    case UPDATE_SELECTED_ITEMS:
      let existingItems = state.selectedItemsId;

      if(!existingItems.includes(state.selectedItemId)) {
        existingItems.push(state.selectedItemId)
      }

      const commonParent = getParentId(existingItems[0])
      const selectedItemParent = getParentId(action.data)

      // if the newly selected item doesn't share the same parent
      // with the already selected items, clear the selected items
      if(commonParent === selectedItemParent && !existingItems.includes(action.data)) {
        existingItems.push(action.data)
      } else {
        existingItems = []
      }

      return {
        ...state,
        selectedItemsId: existingItems,
      };
    case CLEAR_SELECTED_ITEMS:
      return {
        ...state,
        selectedItemsId: [],
      }
    case SET_MULTIPLE_SELECTION:
      return {
        ...state,
        isMultipleSelection: action.data,
      }
    default:
      return state
  }
}
